/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Card,
  Grid,
  Typography,
  useTheme,
  Button,
  Box,
  List,
  ListItemButton,
  Divider,
  useMediaQuery,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MapComponent from "../../components/MapComponent";
import CuverdCouponCard from "./CuverdCouponCard";
import CouponSaveButtonView from "./CouponSaveButtonView";
import { connect } from "react-redux";
import { gaugeActions, homeActions } from "actions";
import heartIcon from "assets/images/heartIcon/heart-30.png";
import heartFilledIcon from "assets/images/heartIcon/heart-filled-30.png";
import { config } from "../../constants";
import { authHeader } from "../../helpers";
import {
  checkFavPharmacy,
  checkIfDTC,
  handleDTCFavPharmacy,
  hideCVDFavoriteView,
} from "pages/home/CommonFunctions";
import ForwardToInbox from "assets/images/coupon-share.png";
import { gaugeService } from "../../services/gauge.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GenericCouponView = (props) => {
  const {
    genericDetails,
    selectedGenericItem,
    resetDoseReminderData,
    resetRefillSavingsData,
    getGenericDetails,
    selectedGenericInfo,
    updateGTMDataLayer,
    pharmacyGroupList,
    //getPharmacyGroup,
    authData,
    updateSelectedPharmacy = null,
    genericDetailsIsProgress,
    showGauge = false,
    organizationInfo,
    fromPrescriptions = false,
    couponData = null,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesminWidth = useMediaQuery("(max-width:350px)");
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const dtcVisibility = handleDTCFavPharmacy(authData) && checkFavPharmacy();
  const iconTextVisibility = selectedGenericItem?.favoritePharmacyFlag === "Y";
  const [favoriteIcon, setFavoriteIcon] = useState(
    iconTextVisibility || dtcVisibility ? heartFilledIcon : heartIcon
  );
  const btnText =
    iconTextVisibility || dtcVisibility
      ? "Unselect Favorite Pharmacy"
      : "Select Favorite Pharmacy";
  const [favoritePharmacyText, setFavoritePharmacyText] = useState(btnText);
  // const tagManagerArgs = {
  //   dataLayer: gtmInfo,
  //   dataLayerName: "PageDataLayer",
  // };
  const favPharGroupId = localStorage.getItem("pharmacyGroupId");
   const isHCPTemplate =
     organizationInfo?.type?.toLowerCase() === "h" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  const isShowGaugeFlag =
    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
    "y"; 

  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const showFavOptions =
    !hideCVDFavoriteView(authData) || dtcVisibility || checkIfDTC(authData);

  const [favPharLoc, setFavPharLoc] = useState(null);
  const [expanded, setExpanded] = React.useState(isHCPTemplate ? true : false);
  const [showPharmacyList, setShowPharmacyList] = useState(false);
  const [showPharmacyLocationPopup, setPharmacyLocationPopup] = useState(false);
  // const [isPharmacyListCancel, setIsPharmacyListCancel] = useState(true);
  const [alignment, setAlignment] = React.useState("left");
  const [cancelFavPharPopup, setCancelFavPharPopup] = useState(false);
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const [showLoader, setShowLoader] = useState(false);

  const [showShareHCPPopup, setShowShareHCPPopup] = useState(false);
  const [selectedHCPPharmacyGroupId, setSelectedHCPPharmacyGroupId] =
    useState(false);
  let launchRef = useRef(null);

  const fetchPharmacyGroupList = (delay) => {
    if (selectedGenericInfo && showFavOptions && !isHCPTemplate) {
      setTimeout(() => {
        setShowPharmacyList(true);
      }, delay);
    }
  };

  useEffect(() => {
    return () => {
      setSelectedPharmacy(null);
      resetDoseReminderData();
      resetRefillSavingsData();
      setFavPharLoc(null);
      // updateGTMDataLayer({
      //   event: "View_Coupon_Discount",
      //   page: "Discount Coupon Card",
      //   screen: "Discount Coupon Card",
      //   screen_referrer: "Discount Coupon Card",
      // });
    };
  }, []);

  useEffect(() => {
    if (launchRef?.current && selectedPharmacy?.pharmacyType === "M") {
      launchRef?.current?.click();
    }
  }, [launchRef, selectedPharmacy]);

  useEffect(() => {
    if (!cancelFavPharPopup && (!favPharGroupId || favPharGroupId == "null")) {
      fetchPharmacyGroupList(4000);
    }
  }, [selectedGenericInfo]);

  useEffect(() => {
    console.log("favPharGroupId", favPharGroupId);
    if (selectedGenericItem) {
      if (selectedGenericItem?.pharmacyGroupId == favPharGroupId) {
        setFavoriteIcon(heartFilledIcon);
        setFavoritePharmacyText("Unselect Favorite Pharmacy");
      } else {
        setFavoritePharmacyText("Select Favorite Pharmacy");
        setFavoriteIcon(heartIcon);
      }
    }
  }, [selectedGenericItem]);

  const findFavPharmacyLocation = () => {
    let locData = genericDetails?.pharmacyDetailPrice.filter(
      (item) => item.favoritePharmacyLocationFlag === "Y"
    );
    if (locData.length) {
      localStorage.setItem("pharmacyLocationId", locData[0]?.id);
      setFavPharLoc(locData[0]?.id);
      setSelectedPharmacy(locData[0]);
      // setFavoriteIcon(heartFilledIcon);
      // setFavoritePharmacyText("Unselect Favorite Pharmacy");
    } else {
      setSelectedPharmacy(genericDetails?.pharmacyDetailPrice[0]);
      // setFavoritePharmacyText("Select Favorite Pharmacy");
      // setFavoriteIcon(heartIcon);
    }
  };

  useEffect(() => {
    if (
      genericDetails &&
      genericDetails?.pharmacyDetailPrice &&
      genericDetails?.pharmacyDetailPrice[0]
    ) {
      findFavPharmacyLocation();

      updateGTMDataLayer({
        event: "View_Coupon_Discount",
        page: fromPrescriptions
          ? "Discount Coupon Card - Prescriptions"
          : "Discount Coupon Card",
        screen: fromPrescriptions
          ? "Discount Coupon Card - Prescriptions"
          : "Discount Coupon Card",
        screen_title: fromPrescriptions
          ? "Discount Coupon Card - Prescriptions"
          : "Discount Coupon Card",
        adjudication_id:
          genericDetails &&
          genericDetails?.pharmacyDetailPrice &&
          genericDetails?.adjudicationId,
        coupon_url: genericDetails?.pharmacyDetailPrice[0]?.mailOrderUrl,
        coupon_provider: genericDetails?.id,
        fromPrescriptions: fromPrescriptions ? "Y" : "N",
      });
    }
  }, [genericDetails]);

  useEffect(() => {
    if (
      selectedGenericInfo &&
      selectedGenericItem &&
      !genericDetailsIsProgress
    ) {
      getMyGenericDetails();
    }
  }, [selectedGenericInfo]);

  const getMyGenericDetails = async () => {
    if (selectedGenericInfo) {
      let hasFavPharmacy = false;
      if (selectedGenericItem?.triggerPharmacyNew) {
        setShowLoader(true);
        const pharmacyData = await gaugeService?.getGenericList({
          productDetailId: selectedGenericInfo?.productDetailId,
          zipCode: storedZipData?.zipCode || selectedGenericInfo?.zipCode,
          quantity: selectedGenericInfo?.quantity,
          insuranceId: selectedGenericInfo?.id,
          type: "P",
        });
        setShowLoader(false);
        const { favoritePharmacy = null } = pharmacyData?.data;
        if (favoritePharmacy !== null) {
          hasFavPharmacy = true;
          getGenericDetails({
            productDetailId: selectedGenericInfo?.productDetailId,
            offerId: favoritePharmacy?.offerId,
            insuranceId: selectedGenericInfo?.insuranceId,
            pbmPharmacyLocationId: favoritePharmacy?.pbmPharmacyLocationId,
            zipCode: storedZipData?.zipCode || selectedGenericInfo?.zipCode,
            quantity: selectedGenericInfo?.quantity,
            pbmProductDetailId: favoritePharmacy?.pbmProductDetailId,
            pharmacyGroupPbmId: favoritePharmacy?.pharmacyGroupPbmId,
            pbmId: favoritePharmacy?.pbmId,
          });
        }
      }
      setShowLoader(false);
      if (!hasFavPharmacy) {
        getGenericDetails({
          productDetailId: selectedGenericInfo?.productDetailId,
          offerId: selectedGenericInfo?.offerId,
          insuranceId: selectedGenericInfo?.insuranceId,
          pbmPharmacyLocationId: selectedGenericInfo?.pbmPharmacyLocationId,
          zipCode: storedZipData?.zipCode || selectedGenericInfo?.zipCode,
          quantity: selectedGenericInfo?.quantity,
          pbmProductDetailId: selectedGenericInfo?.pbmProductDetailId,
          pharmacyGroupPbmId: selectedGenericInfo?.pharmacyGroupPbmId,
          pbmId: selectedGenericInfo?.pbmId,
        });
      }
    }
  };

  const displaySavingsTxt = (item) => {
    let txt = null;

    if (item?.pharmacyType === "M") {
      txt = "BEST MAIL PRICE!";
    } else if (
      (item?.displayType === "L" || item?.displayType === "E") &&
      (item?.lowestPrice === "Y" ||
        !genericDetails?.lowestPricePharmacy ||
        genericDetails?.lowestPricePharmacy === null)
    ) {
      txt = "BEST PRICE!";
    }
    return (
      <Typography
        variant={(txt === "BEST PRICE!" || txt === "BEST MAIL PRICE!") ? "h3LatoBoldNew" : ""}
        style={{
          display: "flex",
          justifyContent: "end",
          fontSize: isHCPTemplate ? (matches ? "10px" : "14px") : undefined,
        }}
      >
        {(txt === "BEST PRICE!" || txt === "BEST MAIL PRICE!") ? (
          <>
            ${item.price?.toFixed(2)} <br /> {txt}
          </>
        ) : (
          <>${item.price?.toFixed(2)}</>
        )}
      </Typography>
    );
  };

  const renderLogoView = (item, isFavPopup = false) => {
    if (item && item.logoURL) {
      return (
        <div>
          <img
            src={item && item.logoURL}
            alt="logo"
            style={{
              width: isFavPopup ? "40%" : "60%", //matchesMinWidth ? "60%" : "40%",
            }}
          />
        </div>
      );
    } else {
      return (
        <Typography
          variant="h3LatoBlack"
          sx={{
            fontSize: matchesMinWidth ? "15px" : undefined,
            height: matchesMinWidth ? "60px" : "80px",
            alignItems: "center",
            display: "flex",
          }}
          component="span"
        >
          {item.name || item.pharmacyName}
        </Typography>
      );
    }
  };

  const handleClose = () => {
    setShowPharmacyList(false);
  };
  function pharmacyRecord(item, index) {
    return (
      <>
        <Box
          sx={{
            width: "100%",
            cursor: "pointer",
            padding: "10px",
          }}
          onClick={() => {
            if (!isHCPTemplate) {
              updateSelectedPharmacy(item);
              setExpanded(false);
            }

            if (isHCPTemplate) {
              setSelectedHCPPharmacyGroupId(item?.pharmacyGroupId);
              setShowShareHCPPopup(true);
            }
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box sx={{ alignItems: "center", display: "flex", width: "55%" }}>
              {renderLogoView(item)}
              {localStorage.getItem("pharmacyGroupId") ==
                item?.pharmacyGroupId &&
                !isHCPTemplate && (
                  <img
                    className="fav-heart-icon"
                    src={heartFilledIcon}
                    alt="Favorite Icon"
                  />
                )}
            </Box>

            <Box
              sx={{
                display: "flex",
                width: "45%",
                alignItems: "center",
                justifyContent: "end",
                textAlign: "end",
              }}
            >
              {isHCPTemplate && (
                <Typography
                  variant="h3LatoBold"
                  sx={{
                    //color: item?.lowestPrice === "N" ? "#003d4c" : "#03952a",
                    fontSize: matches ? "14px" : undefined,
                    width: "100%",
                  }}
                >
                  <img
                    alt="Text Coupon"
                    onClick={() => {
                      if (isHCPTemplate) {
                        setSelectedHCPPharmacyGroupId(item?.pharmacyGroupId);
                        setShowShareHCPPopup(true);
                      }
                    }}
                    style={{ cursor: "pointer", width: "40%" }}
                    src={ForwardToInbox}
                  />
                </Typography>
              )}
              <Typography
                variant="h3LatoBold"
                sx={{
                  //color: item?.lowestPrice === "N" ? "#003d4c" : "#03952a",
                  fontSize: matches ? "14px" : undefined,
                  width: "100%",
                }}
              >
                {/* {(item?.lowestPrice === "Y" ||
                  !genericDetails?.lowestPricePharmacy ||
                  genericDetails?.lowestPricePharmacy === null) &&
                  selectedGenericItem?.lowestPrice === "N" &&
                  (index === 0 ||
                    (index === 1 &&
                      genericDetails?.otherPharmacies[0].pharmacyType ===
                        "M")) && (
                    <div style={{ fontSize: matches ? "18px" : "22px" }}>
                      ${item.price?.toFixed(2)} <br />
                    </div>
                  )} */}
                {displaySavingsTxt(item, index)}{" "}
              </Typography>
            </Box>
          </Box>
          {item.pharmacyType !== "M" && (
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Typography
                variant="h4LatoMedium"
                component="div"
                sx={{
                  color: theme.palette.common.textGrey2,
                  width: "90%",
                }}
              >
                {item && item.distance?.toFixed(2)} mi
              </Typography>
            </Box>
          )}
        </Box>
        <Divider />
      </>
    );
  }
  const renderPharmacyList = () => {
    return (
      <Box
        sx={{
          minHeight: "50px",
          maxHeight: "300px",
          overflowY: "auto",
          marginBottom: "1rem",
          padding: matches ? "0px" : "10px",
        }}
      >
        <Divider />
        {genericDetails &&
          genericDetails?.otherPharmacies &&
          isHCPTemplate &&
          [
            { ...selectedPharmacy, displayType: "L", lowestPrice: "Y" },
            { ...genericDetails?.mailOrderPharmacy },
            ...genericDetails?.otherPharmacies,
          ]?.map((item, index) => {
            if (item.pharmacyType === "R" || item.pharmacyType === "M") {
              return pharmacyRecord(item, index);
            }
          })}

        {genericDetails &&
          genericDetails?.otherPharmacies &&
          !isHCPTemplate &&
          [
            { ...genericDetails?.mailOrderPharmacy },
            ...genericDetails?.otherPharmacies,
          ]?.map((item, index) => {
            if (item.pharmacyType === "R" || item.pharmacyType === "M") {
              return pharmacyRecord(item, index);
            }
          })}

        {/* {genericDetails && genericDetails?.mailOrderPharmacy ? (
          <List
            key={genericDetails?.mailOrderPharmacy.pharmacyLocationId}
            sx={{ cursor: "pointer" }}
          >
            <ListItem
              onClick={() => {
                if (!isHCPTemplate) {
                  updateSelectedPharmacy(genericDetails?.mailOrderPharmacy);
                }
                if (isHCPTemplate) {
                  setSelectedHCPPharmacyGroupId(
                    genericDetails?.mailOrderPharmacy?.pharmacyGroupId
                  );
                  setShowShareHCPPopup(true);
                }
              }}
              sx={{
                "&:hover": { cursor: "pointer" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 2,
                  width: "100%",
                  backgroundColor: `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                  padding: "0 8px",
                }}
              >
                <ListItemText
                  primary={genericDetails?.mailOrderPharmacy?.name}
                  primaryTypographyProps={{
                    fontSize: matchesMinWidth ? "14px" : "22px",
                    color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}`,
                    textTransform: "none",
                    fontFamily: "Lato-Bold",
                  }}
                  secondary="It is simple & convenient"
                  secondaryTypographyProps={{
                    fontFamily: "Lato-Heavy",
                    fontSize: matchesMinWidth ? "13px" : "15px",
                    color: `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color}`,
                  }}
                />
                {isHCPTemplate && (
                  <Typography
                    variant="h3LatoBold"
                    sx={{
                      //color: item?.lowestPrice === "N" ? "#003d4c" : "#03952a",
                      fontSize: matches ? "14px" : undefined,
                      width: "24%",
                      // display: "flex",
                      // alignItems: "center",
                      // justifyContent: "center",
                    }}
                    component={"div"}
                  >
                    <img
                      alt="Text Coupon"
                      onClick={() => {
                        if (isHCPTemplate) {
                          setSelectedHCPPharmacyGroupId(
                            genericDetails?.mailOrderPharmacy?.pharmacyGroupId
                          );
                          setShowShareHCPPopup(true);
                        }
                      }}
                      style={{ cursor: "pointer", width: "40%" }}
                      src={ForwardToInbox}
                    />
                  </Typography>
                )}
                <div
                  className="price-view"
                  sx={{
                    paddingRight: "8px",
                  }}
                >
                  <Typography
                    variant="h3LatoBold"
                    sx={{
                      fontSize: isHCPTemplate
                        ? matches
                          ? "10px"
                          : "14px"
                        : undefined,
                    }}
                  >
                    ${genericDetails?.mailOrderPharmacy?.price?.toFixed(2)}
                  </Typography>
                </div>
              </Box>
              {!isHCPTemplate && (
                <ChevronRight
                  sx={{
                    color: `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                  }}
                />
              )}
            </ListItem>
            <Divider />
          </List>
        ) : null} */}
      </Box>
    );
  };

  const renderPharmacyListDiaglog = () => {
    return (
      <Box
        sx={{
          minHeight: "50px",
          maxHeight: "300px",
          overflowY: "auto",
          marginBottom: "1rem",
          padding: matches ? "0px" : "10px",
        }}
      >
        <Divider />
        {pharmacyGroupList &&
          pharmacyGroupList?.map((item) => {
            return (
              <>
                <Box
                  sx={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={() => {
                    setExpanded(false);

                    handleClose();
                    if (showPharmacyList) {
                      //check if the selected pharmacy is same as that of favorite pharmacy
                      var pharmacyGroupId = item.id;
                      var isUpdatePharmacy =
                        selectedPharmacy?.pharmacyGroupId !== pharmacyGroupId;
                      markAsFavoriteLocation(item).then(() => {
                        if (isUpdatePharmacy) {
                          var pharmacy = genericDetails?.otherPharmacies?.find(
                            (item) => item.pharmacyGroupId == pharmacyGroupId
                          );
                          if (pharmacy) {
                            updateSelectedPharmacy(pharmacy);
                          }
                        }
                      });
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        // height: "40px",
                      }}
                    >
                      {renderLogoView(item, true)}
                    </Box>
                    <Box component="span">
                      <img
                        className="fav-heart-icon"
                        src={heartIcon}
                        alt="Favorite Icon"
                        onMouseOver={(e) => {
                          e.target.src = heartFilledIcon;
                        }}
                        onMouseOut={(e) => {
                          e.target.src = heartIcon;
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Typography
                      variant="h4LatoMedium"
                      component="div"
                      sx={{
                        color: theme.palette.common.textGrey2,
                        width: "90%",
                      }}
                    >
                      {item && item.distance?.toFixed(2)} mi &nbsp;
                    </Typography>
                  </Box>
                </Box>
                <Divider />
              </>
            );
          })}
      </Box>
    );
  };

  const markAsUnFavorite = async () => {
    const options = {
      baseURL: config.apiUrl,
      url: `/coupon/unsetfavoritepharmacy`,
      method: "GET",
      headers: authHeader(),
    };
    try {
      const response = await axios(options);
      if (response?.data?.success) {
        setFavoritePharmacyText("Select Favorite Pharmacy");
        setFavoriteIcon(() => alterFavoriteIcon());
        localStorage.setItem("pharmacyGroupId", null);
        localStorage.setItem("pharmacyLocationId", null);
        fetchPharmacyGroupList(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const markAsFavoriteLocation = async (item) => {
    let pharmacyLocationId = selectedGenericItem.pharmacyLocationId;
    let pharmacyGroupId = selectedGenericItem.pharmacyGroupId;
    if (item) {
      pharmacyLocationId = item.pharmacyLocationId || item?.id;
      pharmacyGroupId = item?.pharmacyGroupId || item.id;
    }
    const options = {
      baseURL: config.apiUrl,
      url: `/coupon/setfavoritepharmacy/${pharmacyLocationId}/${pharmacyGroupId}`,
      method: "GET",
      headers: authHeader(),
    };
    try {
      const response = await axios(options);
      if (response?.data?.success) {
        setExpanded(false);
        setFavPharLoc(pharmacyLocationId);
        setFavoriteIcon(heartFilledIcon);
        setFavoritePharmacyText("Unselect Favorite Pharmacy");
        localStorage.setItem("pharmacyGroupId", pharmacyGroupId);
        localStorage.setItem("pharmacyLocationId", pharmacyLocationId);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const alterFavoriteIcon = () => {
    if (favoriteIcon == heartIcon) {
      return heartFilledIcon;
    } else {
      return heartIcon;
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
        }}
      >
        <Card
          sx={{
            height: "100%",
            boxShadow: 0,
            paddingLeft: matches ? 2 : "124px",
            paddingRight: matches ? 2 : "124px",
          }}
        >
          {genericDetailsIsProgress || showLoader ? (
            <div
              style={{
                height: "300px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <CircularProgress
                style={{ color: theme?.palette?.secondary?.main }}
              />
            </div>
          ) : (
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {selectedGenericItem?.pharmacyType === "M" ? (
                <Grid
                  item
                  sm={12}
                  mb={2}
                  mt={2}
                  sx={{
                    //minHeight: "410px",
                    height: "300px",
                    border: `solid 1px ${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      mt={1}
                      mb={4}
                      sx={{ textAlign: "center", padding: "8px" }}
                    >
                      <Typography variant="h2LatoMedium">
                        Use the LAUNCH SITE button to open the <br /> website in
                        another window.
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Button
                        ref={launchRef}
                        id="launchSite"
                        variant="large"
                        sx={{ minWidth: matchesMinWidth ? 200 : 400 }}
                        onClick={() =>
                          window.open(
                            selectedPharmacy?.mailOrderUrl,
                            "_blank",
                            "location=yes,height=570,width=1250, left=100, top=100, status=yes"
                          )
                        }
                      >
                        LAUNCH SITE
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ) : (
                <Grid sx={{ width: "100%" }} item sm={12} mb={matches ? 0 : 0}>
                  <>
                    <>
                      {favoritePharmacyText !== null &&
                      !isHCPTemplate &&
                      showFavOptions ? (
                        <Button
                          variant="text"
                          sx={{
                            marginLeft: "-2%",
                            marginTop: "0px",
                            textTransform: "none",
                            minWidth: "0px",
                            padding: "0px",
                            height: "40px",
                          }}
                          onClick={() =>
                            favoritePharmacyText?.toLowerCase() ===
                            "select favorite pharmacy"
                              ? markAsFavoriteLocation(
                                  undefined,
                                  "generic_list"
                                )
                              : markAsUnFavorite()
                          }
                        >
                          <Box component="span">
                            <img
                              className="fav-heart-icon"
                              src={favoriteIcon}
                              alt="Favorite Icon"
                            />
                          </Box>
                          <Box
                            component="span"
                            sx={{ marginBottom: "12px", marginLeft: "5px" }}
                          >
                            <Typography variant="h4LatoBold">
                              {favoritePharmacyText}
                            </Typography>
                          </Box>
                        </Button>
                      ) : null}
                      {selectedPharmacy && (
                        <>
                          {!isHCPTemplate &&
                            genericDetails?.otherPharmacies &&
                            genericDetails?.otherPharmacies?.length > 0 && (
                              <Grid sx={{ display: "flex" }}>
                                <Typography
                                  sx={{
                                    marginLeft: "-2%",
                                    //color: "#03952A",
                                    fontSize: matches ? "16px" : "20px",
                                    cursor: "pointer",
                                  }}
                                  variant="h3LatoBlackNew"
                                  component="span"
                                  onClick={() => {
                                    setExpanded(!expanded);
                                  }}
                                >
                                  {selectedGenericItem?.lowestPrice === "Y" ||
                                  !genericDetails?.lowestPricePharmacy ||
                                  genericDetails?.lowestPricePharmacy ===
                                    null ? (
                                    <>View savings</>
                                  ) : (
                                    <>
                                      Save up to{" "}
                                      <Typography
                                        variant="h3LatoBlackNew"
                                        component="span"
                                      >
                                        {genericDetails?.priceDifferenceWithLowestPrice
                                          ?.toFixed(2)
                                          .replace("-", "$")}
                                      </Typography>{" "}
                                      more
                                    </>
                                  )}{" "}
                                  at nearby pharmacies
                                </Typography>
                                {!expanded ? (
                                  <ExpandMoreIcon
                                    sx={{
                                      fontSize: matches ? "18px" : undefined,
                                    }}
                                    onClick={() => {
                                      setExpanded(!expanded);
                                    }}
                                  />
                                ) : (
                                  <ExpandLessIcon
                                    sx={{
                                      fontSize: matches ? "18px" : undefined,
                                    }}
                                    onClick={() => {
                                      setExpanded(!expanded);
                                    }}
                                  />
                                )}
                              </Grid>
                            )}
                          <Accordion
                            expanded={expanded}
                            style={{
                              border: "1px solid #ccc",
                              width: "100%",
                              marginTop: "1%",
                              marginLeft: matchesminWidth
                                ? "-5%"
                                : matchesMinWidth
                                ? "-3%"
                                : "-2%",
                            }}
                          >
                            {(!expanded ||
                              selectedGenericItem?.lowestPrice === "Y" ||
                              !genericDetails?.lowestPricePharmacy ||
                              genericDetails?.lowestPricePharmacy === null) &&
                              !isHCPTemplate && (
                                <AccordionSummary
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Box
                                    sx={{
                                      width: "100%",
                                      paddingLeft: "20px",
                                      paddingTop: matches ? "0px" : "10px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: isHCPTemplate ? "100%" : "65%",
                                        }}
                                      >
                                        {renderLogoView(selectedPharmacy)}
                                      </Box>
                                      {isHCPTemplate && (
                                        <Typography
                                          variant="h3LatoBold"
                                          sx={{
                                            //color: item?.lowestPrice === "N" ? "#003d4c" : "#03952a",
                                            fontSize: matches
                                              ? "14px"
                                              : undefined,
                                            width: "30%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "end",
                                          }}
                                          component={"div"}
                                        >
                                          <img
                                            alt="Text Coupon"
                                            onClick={() => {
                                              if (isHCPTemplate) {
                                                setSelectedHCPPharmacyGroupId(
                                                  selectedPharmacy?.pharmacyGroupId
                                                );
                                                setShowShareHCPPopup(true);
                                              }
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              width: "43%",
                                            }}
                                            src={ForwardToInbox}
                                          />
                                        </Typography>
                                      )}
                                      <Box
                                        sx={{
                                          width: "40%",
                                          paddingRight: "30px",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "end",
                                          }}
                                        >
                                          <Typography
                                            variant="h3LatoBlackNew"
                                            component="span"
                                          >
                                            $
                                            {selectedPharmacy &&
                                              selectedPharmacy.price?.toFixed(
                                                2
                                              )}
                                          </Typography>
                                        </Box>
                                        {(selectedGenericItem?.lowestPrice ===
                                          "Y" ||
                                          !genericDetails?.lowestPricePharmacy ||
                                          genericDetails?.lowestPricePharmacy ===
                                            null) && (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "end",
                                            }}
                                          >
                                            <Typography
                                              variant="h3LatoBoldNew"
                                              sx={{
                                                paddingLeft: "5px",
                                              }}
                                            >
                                              BEST PRICE!
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    </Box>
                                    {genericDetails?.pharmacyDetailPrice
                                      ?.length &&
                                      !isHCPTemplate && (
                                        <Box
                                          onClick={() => {
                                            setPharmacyLocationPopup(true);
                                          }}
                                        >
                                          <Typography
                                            variant="h4LatoMedium"
                                            component="div"
                                            sx={{
                                              //paddingLeft: "15px",
                                              color:
                                                theme.palette.common.textGrey2,
                                              textDecoration: "underline",
                                            }}
                                          >
                                            {selectedPharmacy.pharmacyGroupName.toUpperCase() ===
                                            "INDEPENDENT"
                                              ? "View Community"
                                              : "Other " +
                                                selectedPharmacy?.pharmacyGroupName}{" "}
                                            pharmacy locations
                                          </Typography>
                                        </Box>
                                      )}

                                    {!expanded && (
                                      <CuverdCouponCard
                                        p
                                        genericDetails={genericDetails}
                                      />
                                    )}
                                  </Box>
                                </AccordionSummary>
                              )}

                            <AccordionDetails>
                              {renderPharmacyList()}
                            </AccordionDetails>
                          </Accordion>
                        </>
                      )}
                    </>
                  </>
                </Grid>
              )}
            </Grid>
          )}
        </Card>
        {!genericDetailsIsProgress && !showLoader && (
          <Box
            component="div"
            sx={{
              backgroundColor: matchesMinWidth ? "#fff" : "#f0f2f2",
              minHeight: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: matchesminWidth ? "0px" : "10px",
            }}
          >
            <CouponSaveButtonView
              txtCouponBtnClass={
                selectedGenericItem?.pharmacyType !== "M"
                  ? "sticky-front"
                  : "sticky-front-mail-order"
              }
              hideTextCouponIcon={expanded}
              selectedGenericItem={selectedGenericItem}
              refreshGenericData={getMyGenericDetails}
              isShowGaugeFlag={isShowGaugeFlag}
              couponData={{
                ...couponData,
                pharmacyGroupId: selectedHCPPharmacyGroupId,
              }}
              showShareHCPPopup={showShareHCPPopup}
              setShowShareHCPPopup={setShowShareHCPPopup}
            />
          </Box>
        )}
      </Box>
      {!genericDetailsIsProgress && !showLoader && (
        <Box
          mt={matches ? 1 : 1}
          mb={matches ? 1 : 1}
          sx={{ textAlign: "center" }}
        >
          <Typography variant="h5LatoRegular" sx={{ color: "#000" }}>
            All product and company names referenced herein are trademarks of
            their respective owners.
          </Typography>
        </Box>
      )}
      {!showGauge &&
        !isHCPTemplate &&
        !fromPrescriptions &&
        (!favPharGroupId || favPharGroupId == "null") && (
          <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={showPharmacyList}
            className="app-dialog"
            TransitionComponent={Transition}
            sx={{
              position: "absolute",
              top: matches ? "350px" : "10%",
              height: matches ? "400px" : undefined,
            }}
          >
            <DialogTitle
              sx={{
                textAlign: "center",
                paddingRight: "0px",
                paddingLeft: "0px",
              }}
            >
              <Box sx={{ textAlign: "center", display: "flex" }}>
                <Typography
                  variant="h2LatoBlackNew"
                  sx={{
                    width: matchesMinWidth ? "90%" : "95%",
                    //color: "#03952a",
                    lineHeight: "1",
                    fontSize: matchesMinWidth ? "18px" : "24px",
                  }}
                >
                  Pick your favorite pharmacy
                </Typography>

                <Typography
                  variant="h2LatoBlack"
                  sx={{
                    cursor: "pointer",
                    lineHeight: "1",
                    fontSize: matchesMinWidth ? "18px" : "24px",
                  }}
                  onClick={() => {
                    // setIsPharmacyListCancel(false);
                    setShowPharmacyList(false);
                    setCancelFavPharPopup(true);
                  }}
                >
                  <CloseIcon />
                </Typography>
              </Box>
              <Box
                px={1}
                sx={{ textAlign: "center", lineHeight: "1", width: "95%" }}
              >
                <Typography
                  variant="h3LatoBold"
                  sx={{ color: "#2C4980", lineHeight: "1", fontSize: "14px" }}
                >
                  (we'll check the best prices there versus others)
                </Typography>
              </Box>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "0px 30px",
              }}
            >
              {renderPharmacyListDiaglog()}
            </DialogContent>
          </Dialog>
        )}
      {showPharmacyLocationPopup && (
        <Dialog
          fullWidth={true}
          maxWidth={"lg"}
          open={showPharmacyLocationPopup}
          className="app-dialog"
          TransitionComponent={Transition}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              paddingRight: "0px",
              paddingLeft: "0px",
            }}
          >
            <Box sx={{ textAlign: "center", display: "flex" }}>
              <Typography
                variant="h2LatoBlack"
                sx={{
                  width: matchesMinWidth ? "90%" : "95%",
                  color: "#03952a",
                  lineHeight: "1",
                  fontSize: matchesMinWidth ? "18px" : "24px",
                }}
              >
                <ToggleButtonGroup
                  value={alignment}
                  exclusive
                  onChange={handleAlignment}
                  aria-label="text alignment"
                >
                  <ToggleButton value="left" aria-label="justified">
                    <FormatAlignJustifyIcon />
                  </ToggleButton>
                  <ToggleButton
                    disabled={
                      organizationInfo?.organizationOptionJson?.showMapFlag !==
                      "Y"
                    }
                    value="right"
                    aria-label="justified"
                  >
                    <PinDropIcon />
                  </ToggleButton>
                </ToggleButtonGroup>
                &nbsp;&nbsp;
                {selectedPharmacy.pharmacyGroupName.toUpperCase() ===
                "INDEPENDENT"
                  ? "Community"
                  : selectedPharmacy?.pharmacyGroupName}{" "}
                pharmacy locations
              </Typography>

              <Typography
                variant="h2LatoBlack"
                sx={{
                  cursor: "pointer",
                  lineHeight: "1",
                  fontSize: matchesMinWidth ? "18px" : "24px",
                }}
                onClick={() => {
                  // setIsPharmacyListCancel(false);
                  setPharmacyLocationPopup(false);
                }}
              >
                <CloseIcon />
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent
            sx={{
              padding: "0px 30px",
            }}
          >
            <Box sx={{ width: "100%", height: "500px" }}>
              {alignment === "right" ? (
                <MapComponent
                  markAsFavoriteLocation={markAsFavoriteLocation}
                  data={genericDetails?.pharmacyDetailPrice || []}
                />
              ) : (
                <Box
                  sx={{
                    minHeight: "50px",
                    maxHeight: "450px",
                    overflowY: "auto",
                    marginBottom: "1rem",
                  }}
                >
                  <Divider />
                  {genericDetails &&
                    genericDetails?.pharmacyDetailPrice &&
                    genericDetails?.pharmacyDetailPrice.map((item, _index) => {
                      return (
                        <Box key={item.id}>
                          <List
                            sx={{
                              cursor: "pointer",
                              // borderTop:
                              //   selectedPharmacy &&
                              //   selectedPharmacy.id === item.id
                              //     ? "1px solid"
                              //     : "none",
                              // borderBottom:
                              //   selectedPharmacy &&
                              //   selectedPharmacy.id === item.id
                              //     ? "1px solid"
                              //     : "none",
                            }}
                          >
                            <ListItemButton
                              sx={{
                                padding: "0.5rem",
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                backgroundColor:
                                  item.id === favPharLoc
                                    ? "rgba(228, 228, 228, 0.5)"
                                    : "none",
                                "&:hover": { cursor: "pointer" },
                              }}
                              onClick={() => {
                                setSelectedPharmacy(item);
                                const lsPharmacyGroupId =
                                  localStorage.getItem("pharmacyGroupId");

                                if (lsPharmacyGroupId == item.pharmacyGroupId) {
                                  markAsFavoriteLocation(item);
                                } else {
                                  markAsFavoriteLocation(item, "generic_list");
                                }
                              }}
                            >
                              <Box
                                sx={{
                                  display: "block",
                                  width: "85%",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="h5LatoBold"
                                  sx={{
                                    fontSize: "14px",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {_index + 1}.
                                </Typography>
                                {item.pharmacyGroupName &&
                                item.pharmacyGroupName.toUpperCase() ===
                                  "INDEPENDENT" ? (
                                  <Typography
                                    variant="h5LatoBold"
                                    sx={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {item.pharmacyName}, &nbsp;
                                  </Typography>
                                ) : null}
                                <Typography
                                  variant="h5LatoBold"
                                  sx={{
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    width: matchesMinWidth ? "65%" : "auto",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item.address1},&nbsp;
                                  {item.city},&nbsp;
                                  {item.state},&nbsp;
                                  {item.zipCode}
                                </Typography>
                                <>
                                  {item.id === favPharLoc ? (
                                    <Box
                                      component="span"
                                      sx={{
                                        position: "relative",
                                        top: "4px",
                                        right: "5px",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      <img
                                        className="fav-heart-icon"
                                        src={favoriteIcon}
                                        alt="Favorite Icon"
                                      />
                                    </Box>
                                  ) : (
                                    <Box
                                      component="span"
                                      sx={{
                                        position: "relative",
                                        top: "4px",
                                        right: "5px",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      <img
                                        className="fav-heart-icon"
                                        src={heartIcon}
                                        alt="Favorite Icon"
                                      />
                                    </Box>
                                  )}
                                </>
                              </Box>
                              <Typography
                                variant="h5LatoBold"
                                sx={{ textDecoration: "underline" }}
                              >
                                {item.distance?.toFixed(2)}&nbsp;mi
                              </Typography>
                            </ListItemButton>
                            <Divider />
                          </List>
                        </Box>
                      );
                    })}
                </Box>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

function mapStatetoProps(state) {
  return {
    genericDetails: state.genericDetails.data,
    genericDetailsIsProgress: state.genericDetails.isProgress,
    selectedGenericInfo: state.globalStoreInfo.selectedGenericInfo,
    gtmInfo: state.gtmInfo.data,
    pharmacyGroupList: state.pharmacyGroupList.data || [],
    authData: state.authentication.authData || {},
    appQuantity: state.productDetails.appQuantity,
    zipData: state.zipData.data,
    selectedInsurance: state.insuranceList.selectedInsurance,
    organizationInfo: state.organizationInfo.data,
  };
}

const mapDispatchToProps = {
  resetDoseReminderData: () => homeActions.resetDoseReminderData(),
  getGenericDetails: (params) => gaugeActions.getGenericDetails(params),
  resetRefillSavingsData: () => homeActions.resetRefillSavingsData(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  getPharmacyGroup: (value) => gaugeActions.getPharmacyGroup(value),
};

export default connect(mapStatetoProps, mapDispatchToProps)(GenericCouponView);
